var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{attrs:{"title":_vm.$t('ImagePreview'),"active":_vm.showModal},on:{"update:active":function($event){_vm.showModal=$event}}},[_c('div',{staticClass:"w-1/6"},[_c('img',{staticClass:"block mx-auto w-full my-0 text-center",attrs:{"src":_vm.URLS_CONSTANTS.assets + 'PackageAttachments/' + _vm.model}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }